import { FC } from "react";
import { OrganizationProfile } from "@clerk/clerk-react";
import SettingsTopBar from "./SettingsTopBar";
import MCPConnectionsSettings from "./MCPConnectionsSettings";
import { Server } from "lucide-react";

const Organization: FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <div className="fixed top-0 left-0 right-0 z-10 bg-white border-b border-gray-200">
        <SettingsTopBar title="Organization Settings" />
      </div>
      <div className="absolute inset-0 top-12 overflow-hidden">
        <OrganizationProfile
          path="/settings/organization"
          routing="path"
          afterLeaveOrganizationUrl="/dashboard"
          appearance={{
            variables: {
              borderRadius: "0"
            },
            elements: {
              rootBox: {
                width: "100%",
                height: "100%",
                margin: "0",
                padding: "0",
                maxWidth: "none",
                overflow: "hidden"
              },
              cardBox: {
                width: "100%",
                height: "100%",
                margin: "0",
                padding: "0",
                maxWidth: "none",
                overflow: "hidden"
              },
              scrollBox: {
                border: "none",
                overflow: "hidden"
              },
              card: {
                boxShadow: "none",
                margin: "0",
                padding: "0",
                border: "none",
                borderRadius: "0",
                height: "100%",
                overflow: "hidden"
              },
              pageScrollBox: {
                height: "100%",
                overflow: "hidden"
              }
            }
          }}
        >
          <OrganizationProfile.Page
            label="MCP Connections"
            url="mcp-connections"
            labelIcon={<Server className="w-4 h-4" />}
          >
            <MCPConnectionsSettings />
          </OrganizationProfile.Page>
        </OrganizationProfile>
      </div>
    </div>
  );
};

export default Organization; 